import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTapeMeasure = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 15,
	viewBox: "0 0 22 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M7 5C8.10457 5 9 5.89543 9 7C9 8.10457 8.10457 9 7 9C5.89543 9 5 8.10457 5 7C5 5.89543 5.89543 5 7 5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7 0C10.866 1.28851e-07 14 3.13401 14 7V9H16V11H22V15H20V13H16V15H3C1.34315 15 7.57013e-08 13.6569 0 12V7C0 3.13401 3.13401 0 7 0ZM7 3C4.79086 3 3 4.79086 3 7C3 9.20914 4.79086 11 7 11C9.20914 11 11 9.20914 11 7C11 4.79086 9.20914 3 7 3Z",
			fill: "currentColor"
		})
	]
});
export default SvgTapeMeasure;
